import { createContext } from 'react';
import useGameAssetsContext from './useGameAssetsContext.hook';
import GameAssetsLoader from './GameAssetsLoader/GameAssetsLoader';
import { Result } from 'antd';
import GameButton from '../UI/GameAnswerButton/GameButton';
import { Sad } from '@styled-icons/boxicons-regular';

export const GameAssetsContext = createContext(null);
export function GameAssetsContextProvider({
  children,
  prepareAssets,
  gameData,
  gameAssetsFolder,
}) {
  const { state, actions } = useGameAssetsContext({
    gameData,
    gameAssetsFolder,
    prepareAssets,
  });
  return (
    <GameAssetsContext.Provider value={{ state, actions }}>
      {state.isReady ? (
        children
      ) : state.error ? (
        <ErrorMessage />
      ) : (
        <GameAssetsLoader />
      )}
    </GameAssetsContext.Provider>
  );
}

function ErrorMessage() {
  return (
    <Result
      icon={<Sad height={100} width={100} />}
      title="Oops!"
      subTitle="Something went wrong. Please try again and contact us if the problem persists"
      extra={
        <GameButton type="primary" onClick={() => window.location.reload()}>
          Try again
        </GameButton>
      }
    />
  );
}
